const DEFAULT_STATE = {
  catalog_items: [],
  meta: { pagination: {} },
  loading: false,
  filterOptions: {},
}

const normalizeFilterOptions = (response = {}) => {
  const raw = response.filters || response
  return {
    manufacturer_id: raw.manufacturers || [],
    brand_id: raw.brands || [],
    collection_id: raw.collections || [],
    product_group: raw.product_groups || [],
    material: raw.materials || [],
    gender: raw.genders || [],
  }
}

export default function framesDataCatalogReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'FRAMES_DATA_CATALOG_LOAD_PENDING':
      return { ...state, loading: true }

    case 'FRAMES_DATA_CATALOG_LOAD_REJECTED':
      return { ...state, loading: false, catalog_items: [], meta: { pagination: {} } }

    case 'FRAMES_DATA_CATALOG_LOAD_FULFILLED':
      return {
        ...state,
        loading: false,
        catalog_items: response?.catalog_items || response?.data?.catalog_items || [],
        meta: response?.meta || response?.data?.meta || { pagination: {} },
      }

    case 'FRAMES_DATA_CATALOG_FILTERS_LOAD_PENDING':
      return { ...state, filterOptions: state.filterOptions || {} }

    case 'FRAMES_DATA_CATALOG_FILTERS_LOAD_REJECTED':
      return { ...state, filterOptions: {} }

    case 'FRAMES_DATA_CATALOG_FILTERS_LOAD_FULFILLED':
      return {
        ...state,
        filterOptions: normalizeFilterOptions(response),
      }

    default:
      return state
  }
}
